import { ChatChannel } from "./Chat";

export type Metric = {
  name: string;
  channel?: ChatChannel;
  params?: Record<string, string>;
};

export const getMetricId = (metric: Metric) =>
  `${metric.name}_${metric.channel || ""}${
    Object.keys(metric.params || {}).length
      ? `_${btoa(
          Object.entries(metric.params || {})
            .map(([k, v]) => `${k}_${v}`)
            .join("_")
        )}`
      : ""
  }`;

export type MetricData = {
  time: Date;
  value: number;
};

export type TopDialogData = {
  value: string;
  count: number;
};

export type SourceInfo = {
  channel: ChatChannel;
  conversations: number;
  connected: number;
  disconnected: number;
  not_handled: number;
};

export type TeamPerformanceInfo = {
  agentId: string;
  conversations: number;
  messages_sent: number;
  mean_time_to_connect: number;
  average_handling_time: number;
  average_first_message_time: number;
};

/** EDNA-2640: unique chats by source. */
export type ChatSource = "ads" | "campaign" | "organic";

export type ChatSourcesPoint = {
  time: string;
  ads: number;
  campaign: number;
  organic: number;
};

export type ChatSourcesData = {
  window_hours: number;
  series: ChatSourcesPoint[];
  totals: Record<ChatSource, number> & { total: number };
};

export type VolumeSummaryInfo = {
  time: string;
  messagesSent: number;
  messagesReceived: number;
  chatsReceived: number;
  chatsHandledByHuman: number;
  chatsInitiatedByHuman: number;
};
